import React, { useEffect } from "react";
import ScheduleCalender from "../../../components/ScheduleService/ScheduleCalender/ScheduleCalender";
import { useTripsCtx } from "../../../context/TripDetailsContext";
import { usePersonSummaryCtx } from "../../../context/PersonSummaryContext";

type Props = {
  params: {
    careGiverId: string;
    careTakerId: string;
  };
};

const ScheduleCalenderContainer: React.FC<Props> = ({ params }) => {
  const { handleManageServiceUsersData, serviceDataCtx } = useTripsCtx();
  const { isLoadingPersonData } = usePersonSummaryCtx();

  useEffect(() => {
    !isLoadingPersonData &&
      !serviceDataCtx[0].length &&
      handleManageServiceUsersData();
  }, [isLoadingPersonData]);
  
  return <ScheduleCalender params={params} />;
};

export default ScheduleCalenderContainer;
